export default __webpack_public_path__ + "static/media/burgerboatsvg.c2c803c0.svg";